import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Routes, provideRouter } from '@angular/router';
import { authenticatedRouteGuards } from '@shared/guard/guard';
import { auth } from '@shared/interceptors/auth/auth.interceptor';
import { baseUrl } from '@shared/interceptors/base-url/base-url.interceptor';
import { cloudflareTurnstile } from '@shared/interceptors/cloudflare-turnstile/cloudflare-turnstile.interceptor';
import { refreshToken } from '@shared/interceptors/refresh-token/refresh-token.interceptor';
import { PageKey } from '@shared/services/page/models/page.key';
import { provideMarkdown } from 'ngx-markdown';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { collaboratorRoute, jobPositionRoute, legalRoute, loginRoute, playgroundRoute, projectRoute, reportsRoute, teamRoute, userRoute, weeklyAllocationsRoute, weeklyAllocationsV2Route } from './features';

export const routes: Routes = [
  ...loginRoute,
  {
    path: 'profile',
    loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: authenticatedRouteGuards,
    data: {
      title: 'Perfil'
    }
  },
  {
    path: 'home',
    loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
    canActivate: authenticatedRouteGuards,
    data: {
      title: 'Home',
      key: PageKey.HOME,
      search: false
    }
  },
  ...userRoute,
  ...legalRoute,
  ...jobPositionRoute,
  ...teamRoute,
  ...collaboratorRoute,
  ...weeklyAllocationsV2Route,
  ...weeklyAllocationsRoute,
  ...projectRoute,
  ...reportsRoute,
  ...playgroundRoute,
  { path: '', pathMatch: 'full', redirectTo: 'home' }
];

export const appConfig: ApplicationConfig = {
  providers: [provideAnimationsAsync(), provideRouter(routes), provideHttpClient(withInterceptors([baseUrl, refreshToken, auth, cloudflareTurnstile])), provideEnvironmentNgxMask(), provideMarkdown()]
};
